import script from "./MapLegendComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MapLegendComponent.vue?vue&type=script&setup=true&lang=js"

import "./MapLegendComponent.vue?vue&type=style&index=0&id=503688c6&lang=css"

const __exports__ = script;

export default __exports__